"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntersection = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
function useIntersection(options) {
    var _a = React.useState(null), entry = _a[0], setEntry = _a[1];
    var observer = React.useRef(null);
    React.useEffect(function () {
        return function () {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, []);
    var ref = React.useCallback(function (element) {
        if (observer.current) {
            observer.current.disconnect();
            observer.current = null;
        }
        if (element === null) {
            setEntry(null);
            return;
        }
        observer.current = new IntersectionObserver(function (_a) {
            var _entry = _a[0];
            setEntry(_entry);
        }, options);
        observer.current.observe(element);
    }, [options === null || options === void 0 ? void 0 : options.rootMargin, options === null || options === void 0 ? void 0 : options.root, options === null || options === void 0 ? void 0 : options.threshold]);
    return [ref, entry];
}
exports.useIntersection = useIntersection;
//# sourceMappingURL=index.js.map